import type { ThemeConfig } from 'antd';
import { colors } from '@/shared/constants/colors';

export const theme: ThemeConfig = {
  token: {
    lineWidth: 2,
    colorPrimary: colors.orange.o500,
    colorLink: colors.orange.o500,
    colorLinkHover: colors.orange.o700,
    colorLinkActive: colors.orange.o900,
    colorInfo: colors.status.info,
    colorSuccess: colors.status.ok,
    colorWarning: colors.status.warn,
    colorError: colors.status.err,
    colorBorder: colors.neutral.g250,
    fontFamily: '"Wix Madefor Text", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    borderRadius: 8,
    fontSize: 13,
    colorBgLayout: colors.neutral.g050,
  },
  components: {
    Layout: {
      siderBg: colors.orange.o500,
      headerBg: colors.orange.o500,
      bodyBg: colors.neutral.g050,
      footerBg: colors.orange.o500,
      footerPadding: '8px 22px',
    },
    Menu: {
      darkItemBg: colors.orange.o500,
      darkSubMenuItemBg: colors.orange.o500,
      darkItemSelectedBg: colors.orange.o700,
      darkItemColor: colors.neutral.white,
      darkItemSelectedColor: colors.neutral.white,
      darkItemHoverColor: colors.neutral.white,
      darkItemHoverBg: colors.orange.o700,
      itemHeight: 36,
      iconSize: 16,
      groupTitleColor: 'rgba(255, 255, 255, 0.55)',
      groupTitleFontSize: 10,
      groupTitleLineHeight: 1.4,
    },
    Drawer: {
      colorBgElevated: colors.orange.o500,
    },
    Table: {
      headerBg: colors.neutral.g025,
      headerColor: colors.neutral.g600,
      headerSplitColor: 'transparent',
      headerSortActiveBg: colors.neutral.g100,
      headerSortHoverBg: colors.neutral.g100,
      fixedHeaderSortActiveBg: colors.neutral.g100,
      borderColor: colors.neutral.g250,
      rowHoverBg: colors.neutral.g050,
      rowSelectedBg: colors.neutral.g100,
      rowSelectedHoverBg: colors.neutral.g100,
      rowExpandedBg: colors.neutral.g050,
      headerBorderRadius: 8,
      fontSize: 12,
      cellPaddingBlockSM: 12,
      cellPaddingInlineSM: 12,
      cellPaddingBlockMD: 12,
      cellPaddingInlineMD: 14,
    },
    Button: {
      defaultShadow: 'none',
      primaryShadow: 'none',
      dangerShadow: 'none',
    },
    Card: {
      borderRadiusLG: 12,
    },
    Tabs: {
      inkBarColor: colors.orange.o500,
      itemActiveColor: colors.orange.o500,
      itemSelectedColor: colors.orange.o500,
      itemHoverColor: colors.neutral.g950,
    },
    Input: {
      hoverBorderColor: colors.neutral.g250,
      activeBorderColor: colors.neutral.g250,
    },
    Select: {
      optionSelectedBg: colors.neutral.g100,
      optionSelectedColor: colors.neutral.g950,
      optionActiveBg: colors.neutral.g050,
      hoverBorderColor: colors.neutral.g250,
      activeBorderColor: colors.neutral.g250,
    },
    Tag: {
      borderRadiusSM: 6,
    },
  },
};
